<script>
  import {mapGetters} from 'vuex';
  import moduleUtils from 'src/app/module/ModuleUtils';
  import http from 'src/http';
  import formBuilderUtils from 'src/app/module/FormBuilderUtils';
  import appConfig from "../../../services/AppConfigService";
  var moment = require('moment');

  export default{
    name: 'SgsRenderFile',
    props: [
      "attr",
      "fieldValue",
      "formIdentifier",
      "moduleType",
      "label",
      "showHint",
      "hintValue",
      "instance"
    ],
    data() {
      return {
        value: [],
        fileList: [],
        header: {
          Authorization: ""
        }
      }
    },
    watch: {
      fieldValue: function(val) {
        val = val ? val : "";
        if (val !== null && !Array.isArray(val) && val.length > 0) {
          let list = JSON.parse(val);
          this.updateFieldValue = list;
          this.value = list;
          list.map(it => {
            if (it.attachmentStatus !== 'REMOVE') {
              this.fileList.push(Object.assign({}, it));
            }
          });
        }
      },
      formIdentifier: function(val) {
        this.url = moduleUtils.resolveFormDesc(this.formIdentifier) + "/attachment";
      }
    },
    computed: {
      ...mapGetters([
        'loggedUser'
      ]),
      updateFieldValue: {
        get: function() {
          return this.fieldValue;
        },
        set: function(newValue) {
          if (this.attr && this.attr.columnName) {
            this.$emit('updateFieldValue', this.attr.columnName, newValue);
          } else if (this.instance) {
            this.$emit('updateFieldValue', newValue, this.instance);
          } else {
            this.$emit('updateFieldValue', newValue);
          }
        }
      }
    },
    methods: {
      resolveUrl: function(hash) {

        // let url = appConfig.filesUrl() + moduleUtils.resolveFormUri(this.formIdentifier) + "/attachment";
        let url = moduleUtils.resolveFormDesc(this.formIdentifier) + "/attachment";
        return hash ? url + "/" + hash : url
      },
      onSuccess: function(response, file, fileList) {

        if (response.meta.code == 500) {

          this.$notify({
            title: 'Error',
            message: this.$t('sgs_render_file_error_upload') + ' ' + response.error,
            type: 'error'
          });

        } else {

          this.value.push(response.body);

          if (_.differenceBy(this.value, [{ 'attachmentStatus': 'REMOVE' }], 'attachmentStatus').length === fileList.length) {
            this.updateFieldValue = this.value;
            this.fileList = [];
            this.value.map(it => {
              if (it.attachmentStatus !== 'REMOVE') {
                this.fileList.push(Object.assign({}, it));
              }
            });
          }
        }
      },
      onRemoveFile: function(file, fileList) {

        let hash = file.hash;
        let attachmentStatus = file.attachmentStatus;

        let positionValue = _.findIndex(this.value, { 'hash' : hash })
        let positionFileList = _.findIndex(this.fileList, { 'hash' : hash })

        if(attachmentStatus === 'INVALID') {

          http.delete(this.resolveUrl(hash));
          this.value.splice(positionValue, 1);

        } else if(attachmentStatus === 'VALID') {

          this.value[positionValue].attachmentStatus = "REMOVE";

          let objectOnPosition = Object.assign({}, this.value[positionValue]);
          objectOnPosition.attachmentStatus = "REMOVE";

          this.value[positionValue] = objectOnPosition;
        }

        this.fileList.splice(positionFileList, 1);
      },
      urlDownloadFile: function(hash) {
        return this.resolveUrl(hash);
      },
      downloadFile: function(file) {
        window.location.href = this.urlDownloadFile(file.hash);
      }
    },
    mounted () {
      this.header["Authorization"] = "Bearer " + this.loggedUser.access_token;
      if (this.fieldValue !== null && !Array.isArray(this.fieldValue) && this.fieldValue.length > 0) {
        let list = JSON.parse(this.fieldValue);
        this.updateFieldValue = list;
        this.value = list;
        list.map(it => {
          if (it.attachmentStatus !== 'REMOVE') {
            this.fileList.push(Object.assign({}, it));
          }
        });
      }
    }
  }
</script>

<template>
  <div>
    <el-popover
      ref="popover"
      v-show="showHint"
      placement="top-start"
      width="200"
      trigger="hover"
      :content="hintValue">
    </el-popover>

    <el-form-item label="temp" v-if="moduleType === 'form'">

      <span slot="label">
        {{label}} <i v-if="showHint && moduleType === 'form'" class="glyphicon glyphicon-question-sign" v-popover:popover />
      </span>

      <el-upload
        :headers="header"
        :on-success="onSuccess"
        :on-remove="onRemoveFile"
        :file-list="fileList"
        :action="resolveUrl()"
        :show-file-list="true"
        :on-preview="downloadFile"
        multiple>
        <el-button
          size="small"
          type="primary"
          :disabled="attr.disableField"
        >
          {{$t("file")}}
        </el-button>
      </el-upload>
    </el-form-item>
    <div v-if="moduleType === 'custom'">
      <el-upload
        :headers="header"
        :on-success="onSuccess"
        :on-remove="onRemoveFile"
        :file-list="fileList"
        :action="resolveUrl()"
        :on-preview="downloadFile"
        multiple>
        <el-button size="small" type="primary">{{$t("file")}}</el-button>
      </el-upload>
    </div>
    <div v-if="moduleType === 'show'">
      <label>{{label}}</label>
      <p v-for="attachment in value">
        <a
          :href="urlDownloadFile(attachment.hash)">
          <i class="glyphicon glyphicon-cloud-download" />
          {{attachment.name}}
        </a>
      </p>
    </div>
    <div v-if="moduleType === 'list'">
      <a v-for="attachment in value"
        :href="urlDownloadFile(attachment.hash)">
        <i class="glyphicon glyphicon-cloud-download" />
        {{attachment.name}},
      </a>
    </div>
  </div>
</template>

<style>
  .el-upload__input {
    display: none !important;
}
</style>



// WEBPACK FOOTER //
// SgsRenderFile.vue?5629918a